// @ts-nocheck
/* eslint-disable */
import React, { useEffect } from 'react';

import cookies from 'js-cookie'
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { PageNotFound } from 'app/components/page-not-found';
import { SystemHeader, SystemIcon } from 'app/components/shared/system-header';
import { ZoningRoutes } from 'app/fare-products/zoningRoutes';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { canViewFaresSubSystems, canViewZoningSubSystems } from 'selectors';

import { DiscountBands } from './discount-bands';
import { PassengersGroups } from './passengers-groups';
import { DocumentTypes } from './document-types';
import { DiscountBandAssignment } from './discount-band-assignment';
 // Set-ExecutionPolicy Bypass -Scope Process -Force

const Zoning: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);
  const intl = useIntl();

  const canViewZoningRoutes = useTypedSelector(state =>
    canViewFaresSubSystems(state, 'Fares','Tickets')
  );

  const canViewDocumentTypes = useTypedSelector(state =>
    canViewFaresSubSystems(state, 'DocumentTypes')
  );

  const canViewPassengersGroups = useTypedSelector(state =>
    canViewFaresSubSystems(state, 'PassengersGroups')
  );

  const canViewFareProducts = useTypedSelector(state =>
    canViewFaresSubSystems(state, 'FareProducts')
  );

  const canViewPromotions = useTypedSelector(state =>
    canViewFaresSubSystems(state, 'Promotions')
  );

  const canViewDiscountBandAssignment = useTypedSelector(state =>
    canViewFaresSubSystems(state, 'DiscountBandAssignment')
  );

  let user: any = '';
  let user2 :any= '';
  let userRefresh:any = '';
  
  const authData = localStorage.getItem("authData");
  
  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    user = parsedAuthData.userData;
    user2 = parsedAuthData.userToken;
    userRefresh = parsedAuthData.userToken;
  }
  

  return (
    <>
      {/* <SystemHeader
        headerTitle={intl.formatMessage({ id: 'zoning' })}
        headerIcon={SystemIcon.zoning}
  /> */}
    <SystemHeader
        headerTitle={intl.formatMessage({ id: 'zoning' })}
        headerIcon={SystemIcon.zoning}
      />

      <Switch>
        <Redirect from={baseURL} exact to={`${baseURL}/zoningRoutes`} />

<Route path={`${baseURL}/zoningRoutes`}>
          {canViewZoningRoutes ? <ZoningRoutes /> : <NotAuthorized />}
</Route>

<Route path={`${baseURL}/document-types`}>
          {canViewDocumentTypes ? <DocumentTypes /> : <NotAuthorized />}
</Route>

<Route path={`${baseURL}/passengers-groups`}>
          {canViewPassengersGroups ? <PassengersGroups /> : <NotAuthorized />}
</Route>

<Route path={`${baseURL}/fare-products`}>
          {canViewFareProducts ? <DiscountBands /> : <NotAuthorized />}
</Route>

<Route path={`${baseURL}/promotions`}>
          {canViewPromotions ? <DiscountBands /> : <NotAuthorized />}
</Route>

<Route path={`${baseURL}/discount-band-assignment`}>
          {canViewDiscountBandAssignment ? <DiscountBandAssignment /> : <NotAuthorized />}
</Route>

        <Route path="/">
          <PageNotFound />
        </Route>
      </Switch>
    </>
  );
};

export { Zoning };
